// Copia con fallback: navigator.clipboard può mancare o essere negato (browser
// datati, permessi); il textarea+execCommand copre quei casi. Ritorna true se copiato.
// Estratto da Affiliazioni.tsx (Task 9, QR per agenzia) per essere riusato anche
// nella scheda «QR dell'agenzia»: stesso comportamento, un solo posto da mantenere.
export async function copyText(text: string): Promise<boolean> {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch {
    try {
      const ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.focus();
      ta.select();
      const ok = document.execCommand("copy");
      document.body.removeChild(ta);
      return ok;
    } catch {
      return false;
    }
  }
}
